module.exports = __webpack_public_path__ + "assets/36bd4602264121c76ad9d61047e2dcd3.svg";